var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-group', [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-input', {
    staticClass: "col",
    attrs: {
      "label": _vm.label,
      "disabled": _vm.isTransparent
    },
    model: {
      value: _vm.color,
      callback: function callback($$v) {
        _vm.color = $$v;
      },
      expression: "color"
    }
  })], 1), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.isTransparent,
      callback: function callback($$v) {
        _vm.isTransparent = $$v;
      },
      expression: "isTransparent"
    }
  }, [_vm._v("透明")])], 1), _c('b-col', {
    attrs: {
      "sm": "1"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.normalizedColor === '',
      expression: "normalizedColor === ''"
    }],
    staticClass: "color-button fa fa-paint-brush",
    attrs: {
      "id": "color-button-".concat(_vm.hash)
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.normalizedColor !== '',
      expression: "normalizedColor !== ''"
    }],
    staticClass: "color-demo",
    style: {
      backgroundColor: _vm.color
    },
    attrs: {
      "id": "color-demo-".concat(_vm.hash)
    }
  })])], 1), _c('b-popover', {
    attrs: {
      "target": "color-button-".concat(_vm.hash),
      "triggers": "click blur"
    }
  }, [_c('swatches-picker', {
    attrs: {
      "value": _vm.color
    },
    on: {
      "input": _vm.updateColor
    }
  })], 1), _c('b-popover', {
    attrs: {
      "target": "color-demo-".concat(_vm.hash),
      "triggers": "click blur"
    }
  }, [_c('swatches-picker', {
    attrs: {
      "value": _vm.color
    },
    on: {
      "input": _vm.updateColor
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }